/**
 * Skills and talent discovery walkthrough.
 * Steps drop automatically when canAccess* / nav visibility fails.
 * @module features/walkthrough/tours/skillsTour
 */

import {
  canAccessMySkillMatrix,
  canAccessResourceFinder,
} from '../../../utils/rolePriority';
import { canManageSkillCatalog } from '../../../utils/userAccess';
import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep } from './navTourHelpers';

const meta = tourMeta('skills-discovery');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const SKILLS_TOUR = {
  id: 'skills-discovery',
  title: meta.title,
  description: meta.description,
  roles: ['employee', 'pm', 'rm', 'csg', 'admin', 'dh'],
  prerequisiteRoute: navItemPath('my-skill-matrix') ?? '/skills/my-matrix',
  priority: 40,
  version: 2,
  visible: (user) =>
    canAccessMySkillMatrix(user) ||
    canManageSkillCatalog(user) ||
    canAccessResourceFinder(user),
  steps: [
    navStep('my-skill-matrix', {
      title: t('walkthrough.skills.mySkills.title'),
      body: t('walkthrough.skills.mySkills.body'),
    }),
    navStep('manage-skills', {
      title: t('walkthrough.skills.manageSkills.title'),
      body: t('walkthrough.skills.manageSkills.body'),
    }),
    navStep('resource-finder', {
      title: t('walkthrough.skills.resourceFinder.title'),
      body: t('walkthrough.skills.resourceFinder.body'),
    }),
  ],
};
